// removed by extract-text-webpack-plugin
module.exports = {"list-home-banner":"list-home-banner","home-banner-wrap":"home-banner-wrap","box-image":"box-image","box-content":"box-content","heading-4":"heading-4","box-full-image":"box-full-image","image":"image","box-action":"box-action","btn":"btn"};


//////////////////
// WEBPACK FOOTER
// ./components/home-banners/_HomeBannerBox.scss
// module id = ./components/home-banners/_HomeBannerBox.scss
// module chunks = 0